module.exports = __webpack_public_path__ + "static/img/product2.1a294326.png";